import React from "react";

const NeueOrderedListStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 4.5L4.5 3V8.5M4.5 8.5H3M4.5 8.5H5.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 12.5H9.9062C9.1755 12.5 8.7682 11.6859 9.1558 11.1074C9.2035 11.0361 9.2711 10.9811 9.3425 10.9336L11.1424 9.736C11.2138 9.6884 11.2812 9.6332 11.3299 9.5626C11.7753 8.9178 11.3213 8 10.5026 8H9",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 13H16.4464C17.6808 13 17.8999 14.8876 16.7601 15.2056C16.7049 15.221 16.647 15.2272 16.5898 15.2292L16 15.25L16.5898 15.2708C16.647 15.2728 16.7049 15.2789 16.7601 15.2944C17.8999 15.6124 17.6808 17.5 16.4464 17.5H15",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueOrderedListStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;